import VideoPlayer from './VideoPlayer';
import videoPlayerView from './videoPlayerComponent.html';
import './videoPlayerComponent.css';

export function videoPlayerComponent() {
	return {
		bindings: {
			url: '=',
			volume: '=?',
			onEnd: '&?',
			onError: '&?',
		},
		controllerAs: 'vm',
		controller: videoPlayerComponentCtrl,
		template: videoPlayerView,
	};
}

class videoPlayerComponentCtrl {
	constructor($scope, $element, modal) {
		'ngInject';
		$scope.$watch('vm.url', this._loadUrl.bind(this));
		$scope.$watch('vm.volume', this._setVolume.bind(this));
		this.element = $element[0].firstChild;
		this.player = new VideoPlayer(this.element, modal);
		this.onEnd = this.onEnd || function () {};
		this.onError =
			this.onError ||
			function (error) {
				console.log('Unable to play video. Error:', JSON.stringify(error));
			};
	}

	_loadUrl() {
		if (!VideoPlayer.isPlayable(this.url)) {
			this.onError({ $message: 'URL not playable: ' + this.url });
		}
		if (this.hasStarted) {
			this.player.stop();
		}
		this._play();
	}

	_play() {
		this.hasStarted = this.player.play(this.url).then(
			() => this.onEnd(),
			() => this.onError({ $message: 'Playback Error for url: ' + this.url })
		);
	}

	_setVolume() {
		if (this.player) {
			this.player.setVolume(this.volume);
		}
	}
}
